import { render } from "./AddCustomerPage.vue?vue&type=template&id=745f42d2&ts=true"
import script from "./AddCustomerPage.vue?vue&type=script&lang=ts"
export * from "./AddCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__